// extracted by mini-css-extract-plugin
export default {"cardTitle":"LicensingPeriodCard_cardTitle_k5JbY","period":"LicensingPeriodCard_period_aKgNn","monthsLeft":"LicensingPeriodCard_monthsLeft_jwdR4"};